import { react2angular } from 'react2angular';

import PaymentError, { WrappedPaymentError } from './PaymentError';

export default PaymentError;
export const AngularPaymentError = react2angular(WrappedPaymentError, ['creditCardErrorCode']);
